export function normalizeEin(value: string): string {
  return value.replace(/\D/g, "");
}

export function isValidEin(value: string): boolean {
  const digits = normalizeEin(value);
  if (digits.length !== 9) return false;
  return !/^(\d)\1+$/.test(digits);
}

export function formatEin(value: string): string {
  const digits = normalizeEin(value).slice(0, 9);
  if (digits.length === 0) return "";
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}-${digits.slice(2)}`;
}

export function maskEinInput(raw: string): string {
  return formatEin(raw);
}
